import OptionsSidebar from 'components/options-sidebar';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import React, { Component } from 'react';
import styles from './styles.css';

export default class CLDealerHome extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='Campo Líder Distribuidor' />
                <div className={styles.gridContainer}>
                    <OptionsSidebar
                        refundType='cl'
                        userType='dealer'
                        // Add back 'crops' to liks when client asks for it.
                        links={['refund', 'kits', 'trialSigns']}
                    />
                    <div className={styles.message}>
                        <p>Realizá tu pedido</p>
                        <p>Para garantizar la entrega correcta del kit de materiales se debe solicitar con 10 días
                        hábiles de anticipación
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/cl-dealer/home/index.js